import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnclearShipment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19 11.4995V6.9905C18.9994 6.64157 18.9066 6.299 18.731 5.99748C18.5554 5.69596 18.3032 5.4462 18 5.2735L11 1.2655C10.6954 1.09151 10.3508 1 10 1C9.64925 1 9.30456 1.09151 9 1.2655L2 5.2725C1.381 5.6275 1 6.2825 1 6.9905V15.0085C1 15.7175 1.381 16.3715 2 16.7255L9 20.7335C9.30456 20.9075 9.64925 20.999 10 20.999M10 20.999C10.3508 20.999 10.6954 20.9075 11 20.7335M10 20.999V10.9995M10 10.9995L18.73 5.95947M10 10.9995L1.26953 5.95947",
		stroke: "CurrentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.5 21V21.01M14 14.7008C14.2888 14.3596 14.6845 14.1262 15.1228 14.0385C15.5611 13.9508 16.0162 14.014 16.414 14.2178C16.8147 14.4219 17.1349 14.7552 17.3229 15.1638C17.5109 15.5724 17.5557 16.0324 17.45 16.4696C17.3444 16.9068 17.0945 17.2956 16.7407 17.5732C16.3868 17.8508 15.9498 18.0011 15.5 17.9998V18.5",
		stroke: "CurrentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgUnclearShipment;
